module.exports = __webpack_public_path__ + "public/files/img/whatsapp.559aa5dd.gif";